import createVueComponent from '../createVueComponent';
var Mountain = createVueComponent('MountainIcon', [['path', {
  d: 'm8 3 4 8 5-5 5 15H2L8 3z',
  key: 'otkl63'
}]]);
export default Mountain;